import { render, staticRenderFns } from "./LoadingExternalPage.vue?vue&type=template&id=4fd7b6f7&scoped=true"
import script from "./LoadingExternalPage.vue?vue&type=script&lang=ts"
export * from "./LoadingExternalPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd7b6f7",
  null
  
)

export default component.exports